export default __webpack_public_path__ + "static/media/ELCM.25b8c455.png";